export const GET_ERRORS = "GET_ERRORS";
export const GET_PROJECTS = "GET_PROJECTS";
export const GET_PROJECT = "GET_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";

//Types for BACKLOG ACTIONS

export const GET_BACKLOG = "GET_BACKLOG";
export const GET_PROJECT_TASK = "GET_PROJECT_TASK";
export const DELETE_PROJECT_TASK = "DELETE_PROJECT_TASK";

//user
export const SET_CURRENT_USER = "SET_CURRENT_USER";

